import React from 'react'
import TopHead from './TopHead'
// import Navbar from './Navbar' 
import NewNavBar from './NewNavBar'

function Header() {
  return (
     <>
     <TopHead/>
     {/* <Navbar/>  */}
     <NewNavBar/>
     </>
  )
}

export default Header